import i18n from "@/lang";
import startCase from "@/utils/string/start-case/index";

/**
 * i18nWrapper is a service that retrieves translations based on the provided parameters.
 * It supports both singular and plural translations and handles missing translation keys gracefully.
 *
 * @param {string} value - The translation key to look up.
 * @param {number} parameters.length - The length to use for plural translations.
 * @param {Object} parameters.argument - Additional arguments for the translation.
 * @returns {string} The translated string or the value in start case if the translation key is not found.
 */

export default function i18nWrapper(value, parameters = { length: 0, argument: {} }) {
  if (typeof value !== "string" || !value) {
    throw new TypeError("The value parameter must be a string");
  }
  if (parameters.length && typeof parameters.length !== "number") {
    throw new TypeError("The length parameter must be a number");
  }
  if (parameters.argument && typeof parameters.argument !== "object") {
    throw new TypeError("The argument parameter must be an object");
  }

  if (!i18n.te(value)) {
    if (process.env.NODE_ENV === "development") {
      /* eslint-disable */
      console.error(`Translation key "${value}" not found in i18n. Returning value in start case.`);
      /* eslint-enable */
    }
    const word = value.split(".").at(-1);
    return startCase({ value: word });
  }

  return i18n.tc(value, parameters.length, parameters.argument);
}
